import React, { FunctionComponent } from 'react';
import { TypographyName } from '@doveit/lego';
import SeoLinksGroups, { SeoLinksGroup } from '../../../components/seo-links-groups/SeoLinksGroups';
import PageSection from '../../../components/page-section/PageSection';
import { URLObject } from '../../../utils/links';

export interface LinkGroupsSectionProps {
  title: string,
  description?: string,
  linkGroups: SeoLinksGroup[],
  onLinkClick: (to: URLObject) => void,
  onTitleClick?: (to: URLObject) => void,
}

export const LinkGroupsSection: FunctionComponent<LinkGroupsSectionProps> = ({
  title,
  description,
  linkGroups,
  onLinkClick,
  onTitleClick,
}) => (
  <PageSection>
    <PageSection.Wrapper>
      <PageSection.Title size={TypographyName.H3}>
        {title}
      </PageSection.Title>
      {description && (
        <PageSection.Description text={description} />
      )}
      <PageSection.Block>
        <SeoLinksGroups
          linkGroups={linkGroups}
          onLinkClick={onLinkClick}
          onTitleClick={onTitleClick}
        />
      </PageSection.Block>
    </PageSection.Wrapper>
  </PageSection>
);

export default LinkGroupsSection;
